<div class="file-upload-modal" *ngIf="isVisible" (click)="onClose()">
  <div class="file-upload-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="file-upload-header">
      <h3 class="file-upload-title">Upload Files</h3>
      <button class="close-button" (click)="onClose()" type="button">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <!-- File Upload Area -->
    <div class="file-upload-area" 
         [class.drag-over]="dragOver"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         (click)="triggerFileInput()">
      
      <div class="upload-icon">
        <i class="fa-solid fa-cloud-arrow-up"></i>
      </div>
      
      <div class="upload-text">
        <h4>Drag and drop files here</h4>
        <p>or <span class="browse-link">browse to choose files</span></p>
      </div>
      
      <div class="file-requirements">
        <p class="requirements-text">
          <i class="fa-solid fa-info-circle"></i>
          Supported formats: PDF, DOCX (max 3MB), TXT (max 1MB)
        </p>
        <p class="requirements-text">
          <i class="fa-solid fa-file-lines"></i>
          Maximum 3 files, ~30 pages per file
        </p>
      </div>
    </div>

    <!-- Hidden file input -->
    <input type="file" 
           id="file-input" 
           multiple 
           accept=".pdf,.docx,.txt"
           (change)="onFileSelected($event)"
           style="display: none;">

    <!-- Selected Files List -->
    <div class="selected-files" *ngIf="selectedFiles.length > 0">
      <h4 class="files-title">Selected Files</h4>
      <div class="files-list">
        <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
          <div class="file-info">
            <div class="file-icon">
              <img *ngIf="file.type === 'application/pdf'" 
                   src="assets/icons/pdf-icon.svg" 
                   alt="PDF Icon" 
                   class="file-type-icon">
              <img *ngIf="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" 
                   src="assets/icons/word-icon.svg" 
                   alt="Word Icon" 
                   class="file-type-icon">
              <img *ngIf="file.type === 'text/plain'" 
                   src="assets/icons/text.svg"
                   alt="Text Icon" 
                     class="file-type-icon">
            </div>
            <div class="file-details">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-size">{{ formatFileSize(file.size) }}</div>
            </div>
          </div>
          <button class="remove-file" (click)="removeFile(i)" type="button">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Error Messages -->
    <div class="error-messages" *ngIf="errors.length > 0">
      <div class="error-item" *ngFor="let error of errors">
        <i class="fa-solid fa-exclamation-triangle"></i>
        <span>{{ error }}</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="file-upload-actions">
      <button class="btn btn-secondary" (click)="onClose()" type="button">
        Cancel
      </button>
      <button class="btn btn-primary" 
              (click)="onUpload()" 
              [disabled]="selectedFiles.length === 0"
              type="button">
        Upload Files ({{ selectedFiles.length }})
      </button>
    </div>
  </div>
</div>
